import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300">
            {t("notFound.title")}
          </h1>
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            {t("notFound.heading")}
          </h2>
          <p className="text-gray-600">{t("notFound.description")}</p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block w-full bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            {t("notFound.goHome")}
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-block w-full bg-gray-200 text-gray-800 px-6 py-3 rounded-md font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            {t("notFound.goBack")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
